import { render, staticRenderFns } from "./DashboardSlider1.vue?vue&type=template&id=08d798e2&scoped=true"
import script from "./DashboardSlider1.vue?vue&type=script&lang=js"
export * from "./DashboardSlider1.vue?vue&type=script&lang=js"
import style0 from "./DashboardSlider1.vue?vue&type=style&index=0&id=08d798e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d798e2",
  null
  
)

export default component.exports